import React from 'react';
import { Link } from 'react-router-dom';

function ReviewCard({ review }) {
  // Calcul de la couleur en fonction de la note (sur 20)
  const getRatingColor = (rating) => {
    if (rating >= 18) return '#00ffcc'; // Excellent (Cyan)
    if (rating >= 15) return '#ec008c'; // Très bon (Rose)
    return '#ffaa00'; // Moyen (Orange)
  };

  return (
    <Link to={`/reviews/${review.id}`} style={{ textDecoration: 'none' }}>
      <div className="review-card-premium" style={styles.card}>
        {/* Image avec Overlay */}
        <div style={{ ...styles.imageWrapper, backgroundImage: `url(${review.image})` }}>
          <div style={styles.ratingBadge}>
            <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{review.rating}</span>
            <span style={{ fontSize: '0.7rem' }}>/20</span>
          </div>
          <div style={styles.overlay}></div>
        </div>

        {/* Infos du Test */}
        <div style={styles.content}>
          <h3 style={styles.title}>{review.title}</h3>
          <p style={styles.verdict}>{review.verdict.substring(0, 80)}...</p>
          
          <div style={{ ...styles.progressBar, borderColor: getRatingColor(review.rating) }}>
            <div style={{ 
              ...styles.progressFill, 
              width: `${(review.rating / 20) * 100}%`, 
              backgroundColor: getRatingColor(review.rating),
              boxShadow: `0 0 10px ${getRatingColor(review.rating)}`
            }}></div>
          </div>
        </div>
      </div>
    </Link>
  );
}

const styles = {
  card: {
    background: '#1a1b26',
    borderRadius: '15px',
    overflow: 'hidden',
    border: '1px solid #222',
    transition: 'transform 0.3s ease, border-color 0.3s ease',
    cursor: 'pointer',
    height: '100%'
  },
  imageWrapper: {
    height: '180px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
  },
  ratingBadge: {
    position: 'absolute',
    top: '15px',
    right: '15px',
    background: 'rgba(0,0,0,0.8)',
    color: '#fff',
    padding: '8px 12px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'baseline',
    gap: '2px',
    zIndex: 2,
    border: '1px solid #ec008c'
  },
  overlay: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '50%',
    background: 'linear-gradient(to top, #1a1b26, transparent)',
  },
  content: { padding: '20px' },
  title: { color: '#fff', margin: '0 0 10px 0', fontSize: '1.2rem', fontWeight: '800' },
  verdict: { color: '#aaa', fontSize: '0.9rem', lineHeight: '1.4', marginBottom: '15px' },
  progressBar: { height: '6px', background: '#0b0b13', borderRadius: '10px', overflow: 'hidden', border: '1px solid #333' },
  progressFill: { height: '100%', borderRadius: '10px', transition: 'width 1s ease-in-out' }
};

export default ReviewCard;